import clsx from 'clsx';
import { ComponentSize } from '../../../types';
import { SPINNER_SIZE } from './Spinner.constants';
import { SpinnerProps } from './Spinner.types';

const Spinner = ({ className, size = ComponentSize.LARGE }: SpinnerProps) => {
  return (
    <div
      className={clsx(
        'loading loading-spinner text-base-content/60',
        typeof size !== 'number' && SPINNER_SIZE[size],
        className
      )}
      style={{ width: typeof size === 'number' ? size : undefined }}
    />
  );
};

export default Spinner;
